module.exports = __webpack_public_path__ + "media/images/university_logos/University-of-Leeds-32f104170b125d7accb3b0354f27a770.svg";